<template>
	<div class="page-container card col-md-8">
		<ThePageHeader :pageTitle="title"></ThePageHeader>
		
		<div class="loading-content d-flex align-items-center justify-content-center">
			<div class="d-flex align-items-center justify-content-center">
				<ProgressSpinner class="ps-2 align-items-center" style="width: 50px; height: 50px;"></ProgressSpinner>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import store from "@/store"
	
	import ThePageHeader from "@/components/ThePageHeader.vue";
	
	export default defineComponent({
		components: {
			ThePageHeader
		},
		props: {
			pageTitle: {
				type: String,
				required: false,
			},
		},
		computed: {
			title() {
				return (this.pageTitle == null ? store.getters.title : this.pageTitle);
			}
		},
	});
</script>